import { MinusCircleOutlined } from "@ant-design/icons";

const MinusCircleIcon = MinusCircleOutlined

export default MinusCircleIcon
